import styled from "styled-components";

export const StyledIconWrapper = styled.div<{ width?: string }>`
  width: ${({ width }) => (width ? width : "2rem")};
  height: ${({ width }) => (width ? width : "2rem")};
`;

export const StyledImg = styled.img<{ imgWidth?: string }>`
  object-fit: contain;
  width: ${({ imgWidth }) => (imgWidth ? imgWidth : "2rem")};
  height: ${({ imgWidth }) => (imgWidth ? imgWidth : "2rem")};
`;
